/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as NoAccessRouteImport } from './routes/no-access'
import { Route as DashboardRouteRouteImport } from './routes/dashboard/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as DashboardReportsRouteImport } from './routes/dashboard/reports'
import { Route as DashboardMySitesRouteImport } from './routes/dashboard/my-sites'
import { Route as DashboardAdminRouteImport } from './routes/dashboard/_admin'
import { Route as AuthVerifyEmailRouteImport } from './routes/auth/verify-email'
import { Route as AuthSignupRouteImport } from './routes/auth/signup'
import { Route as AuthSigninRouteImport } from './routes/auth/signin'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as DashboardWorkspaceRouteRouteImport } from './routes/dashboard/workspace/route'
import { Route as DashboardSettingsRouteRouteImport } from './routes/dashboard/settings/route'
import { Route as DashboardOnboardingRouteRouteImport } from './routes/dashboard/onboarding/route'
import { Route as DashboardInspectionsRouteRouteImport } from './routes/dashboard/inspections/route'
import { Route as DashboardWorkspaceIndexRouteImport } from './routes/dashboard/workspace/index'
import { Route as DashboardSettingsIndexRouteImport } from './routes/dashboard/settings/index'
import { Route as DashboardScopeOfWorksIndexRouteImport } from './routes/dashboard/scope-of-works/index'
import { Route as DashboardOnboardingIndexRouteImport } from './routes/dashboard/onboarding/index'
import { Route as DashboardInspectionsIndexRouteImport } from './routes/dashboard/inspections/index'
import { Route as DashboardEquipmentIndexRouteImport } from './routes/dashboard/equipment/index'
import { Route as DashboardDocumentsIndexRouteImport } from './routes/dashboard/documents/index'
import { Route as DashboardDefectsIndexRouteImport } from './routes/dashboard/defects/index'
import { Route as DashboardWorkspaceInspectionsRouteImport } from './routes/dashboard/workspace/inspections'
import { Route as DashboardWorkspaceInspectionScheduleRouteImport } from './routes/dashboard/workspace/inspection-schedule'
import { Route as DashboardSettingsSecurityRouteImport } from './routes/dashboard/settings/security'
import { Route as DashboardScopeOfWorksScopeOfWorkIdRouteImport } from './routes/dashboard/scope-of-works/$scopeOfWorkId'
import { Route as DashboardOnboardingLinkingRouteImport } from './routes/dashboard/onboarding/linking'
import { Route as DashboardOnboardingEquipmentUploadRouteImport } from './routes/dashboard/onboarding/equipment-upload'
import { Route as DashboardOnboardingDocumentUploadRouteImport } from './routes/dashboard/onboarding/document-upload'
import { Route as DashboardEquipmentEquipmentIdRouteImport } from './routes/dashboard/equipment/$equipmentId'
import { Route as DashboardDocumentsDocumentIdRouteImport } from './routes/dashboard/documents/$documentId'
import { Route as DashboardDefectsDefectIdRouteImport } from './routes/dashboard/defects/$defectId'
import { Route as DashboardAdminUserManagementRouteImport } from './routes/dashboard/_admin/user-management'
import { Route as DashboardAdminSitesRouteImport } from './routes/dashboard/_admin/sites'
import { Route as DashboardAdminCompanyRouteRouteImport } from './routes/dashboard/_admin/company/route'
import { Route as DashboardInspectionsInspectionIdIndexRouteImport } from './routes/dashboard/inspections/$inspectionId/index'
import { Route as DashboardAdminCompanyIndexRouteImport } from './routes/dashboard/_admin/company/index'
import { Route as DashboardInspectionsInspectionIdPaperSheetRouteImport } from './routes/dashboard/inspections/$inspectionId/paper-sheet'
import { Route as DashboardInspectionsInspectionIdHacFormRouteImport } from './routes/dashboard/inspections/$inspectionId/hac-form'
import { Route as DashboardAdminUserUserIdRouteImport } from './routes/dashboard/_admin/user/$userId'
import { Route as DashboardAdminCompanyCompanyIdIndexRouteImport } from './routes/dashboard/_admin/company/$companyId/index'
import { Route as DashboardAdminCompanyCompanyIdSitesIndexRouteImport } from './routes/dashboard/_admin/company/$companyId/sites/index'
import { Route as DashboardAdminCompanyCompanyIdSitesSiteIdRouteImport } from './routes/dashboard/_admin/company/$companyId/sites/$siteId'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const NoAccessRoute = NoAccessRouteImport.update({
  id: '/no-access',
  path: '/no-access',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRouteRoute = DashboardRouteRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardReportsRoute = DashboardReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardMySitesRoute = DashboardMySitesRouteImport.update({
  id: '/my-sites',
  path: '/my-sites',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardAdminRoute = DashboardAdminRouteImport.update({
  id: '/_admin',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const AuthVerifyEmailRoute = AuthVerifyEmailRouteImport.update({
  id: '/auth/verify-email',
  path: '/auth/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/auth/signup',
  path: '/auth/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSigninRoute = AuthSigninRouteImport.update({
  id: '/auth/signin',
  path: '/auth/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardWorkspaceRouteRoute = DashboardWorkspaceRouteRouteImport.update({
  id: '/workspace',
  path: '/workspace',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardSettingsRouteRoute = DashboardSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardOnboardingRouteRoute =
  DashboardOnboardingRouteRouteImport.update({
    id: '/onboarding',
    path: '/onboarding',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardInspectionsRouteRoute =
  DashboardInspectionsRouteRouteImport.update({
    id: '/inspections',
    path: '/inspections',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardWorkspaceIndexRoute = DashboardWorkspaceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardWorkspaceRouteRoute,
} as any)
const DashboardSettingsIndexRoute = DashboardSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardSettingsRouteRoute,
} as any)
const DashboardScopeOfWorksIndexRoute =
  DashboardScopeOfWorksIndexRouteImport.update({
    id: '/scope-of-works/',
    path: '/scope-of-works/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardOnboardingIndexRoute =
  DashboardOnboardingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardOnboardingRouteRoute,
  } as any)
const DashboardInspectionsIndexRoute =
  DashboardInspectionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardInspectionsRouteRoute,
  } as any)
const DashboardEquipmentIndexRoute = DashboardEquipmentIndexRouteImport.update({
  id: '/equipment/',
  path: '/equipment/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardDocumentsIndexRoute = DashboardDocumentsIndexRouteImport.update({
  id: '/documents/',
  path: '/documents/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardDefectsIndexRoute = DashboardDefectsIndexRouteImport.update({
  id: '/defects/',
  path: '/defects/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardWorkspaceInspectionsRoute =
  DashboardWorkspaceInspectionsRouteImport.update({
    id: '/inspections',
    path: '/inspections',
    getParentRoute: () => DashboardWorkspaceRouteRoute,
  } as any)
const DashboardWorkspaceInspectionScheduleRoute =
  DashboardWorkspaceInspectionScheduleRouteImport.update({
    id: '/inspection-schedule',
    path: '/inspection-schedule',
    getParentRoute: () => DashboardWorkspaceRouteRoute,
  } as any)
const DashboardSettingsSecurityRoute =
  DashboardSettingsSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => DashboardSettingsRouteRoute,
  } as any)
const DashboardScopeOfWorksScopeOfWorkIdRoute =
  DashboardScopeOfWorksScopeOfWorkIdRouteImport.update({
    id: '/scope-of-works/$scopeOfWorkId',
    path: '/scope-of-works/$scopeOfWorkId',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardOnboardingLinkingRoute =
  DashboardOnboardingLinkingRouteImport.update({
    id: '/linking',
    path: '/linking',
    getParentRoute: () => DashboardOnboardingRouteRoute,
  } as any)
const DashboardOnboardingEquipmentUploadRoute =
  DashboardOnboardingEquipmentUploadRouteImport.update({
    id: '/equipment-upload',
    path: '/equipment-upload',
    getParentRoute: () => DashboardOnboardingRouteRoute,
  } as any)
const DashboardOnboardingDocumentUploadRoute =
  DashboardOnboardingDocumentUploadRouteImport.update({
    id: '/document-upload',
    path: '/document-upload',
    getParentRoute: () => DashboardOnboardingRouteRoute,
  } as any)
const DashboardEquipmentEquipmentIdRoute =
  DashboardEquipmentEquipmentIdRouteImport.update({
    id: '/equipment/$equipmentId',
    path: '/equipment/$equipmentId',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardDocumentsDocumentIdRoute =
  DashboardDocumentsDocumentIdRouteImport.update({
    id: '/documents/$documentId',
    path: '/documents/$documentId',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardDefectsDefectIdRoute =
  DashboardDefectsDefectIdRouteImport.update({
    id: '/defects/$defectId',
    path: '/defects/$defectId',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardAdminUserManagementRoute =
  DashboardAdminUserManagementRouteImport.update({
    id: '/user-management',
    path: '/user-management',
    getParentRoute: () => DashboardAdminRoute,
  } as any)
const DashboardAdminSitesRoute = DashboardAdminSitesRouteImport.update({
  id: '/sites',
  path: '/sites',
  getParentRoute: () => DashboardAdminRoute,
} as any)
const DashboardAdminCompanyRouteRoute =
  DashboardAdminCompanyRouteRouteImport.update({
    id: '/company',
    path: '/company',
    getParentRoute: () => DashboardAdminRoute,
  } as any)
const DashboardInspectionsInspectionIdIndexRoute =
  DashboardInspectionsInspectionIdIndexRouteImport.update({
    id: '/$inspectionId/',
    path: '/$inspectionId/',
    getParentRoute: () => DashboardInspectionsRouteRoute,
  } as any)
const DashboardAdminCompanyIndexRoute =
  DashboardAdminCompanyIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardAdminCompanyRouteRoute,
  } as any)
const DashboardInspectionsInspectionIdPaperSheetRoute =
  DashboardInspectionsInspectionIdPaperSheetRouteImport.update({
    id: '/$inspectionId/paper-sheet',
    path: '/$inspectionId/paper-sheet',
    getParentRoute: () => DashboardInspectionsRouteRoute,
  } as any)
const DashboardInspectionsInspectionIdHacFormRoute =
  DashboardInspectionsInspectionIdHacFormRouteImport.update({
    id: '/$inspectionId/hac-form',
    path: '/$inspectionId/hac-form',
    getParentRoute: () => DashboardInspectionsRouteRoute,
  } as any)
const DashboardAdminUserUserIdRoute =
  DashboardAdminUserUserIdRouteImport.update({
    id: '/user/$userId',
    path: '/user/$userId',
    getParentRoute: () => DashboardAdminRoute,
  } as any)
const DashboardAdminCompanyCompanyIdIndexRoute =
  DashboardAdminCompanyCompanyIdIndexRouteImport.update({
    id: '/$companyId/',
    path: '/$companyId/',
    getParentRoute: () => DashboardAdminCompanyRouteRoute,
  } as any)
const DashboardAdminCompanyCompanyIdSitesIndexRoute =
  DashboardAdminCompanyCompanyIdSitesIndexRouteImport.update({
    id: '/$companyId/sites/',
    path: '/$companyId/sites/',
    getParentRoute: () => DashboardAdminCompanyRouteRoute,
  } as any)
const DashboardAdminCompanyCompanyIdSitesSiteIdRoute =
  DashboardAdminCompanyCompanyIdSitesSiteIdRouteImport.update({
    id: '/$companyId/sites/$siteId',
    path: '/$companyId/sites/$siteId',
    getParentRoute: () => DashboardAdminCompanyRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/no-access': typeof NoAccessRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/dashboard/inspections': typeof DashboardInspectionsRouteRouteWithChildren
  '/dashboard/onboarding': typeof DashboardOnboardingRouteRouteWithChildren
  '/dashboard/settings': typeof DashboardSettingsRouteRouteWithChildren
  '/dashboard/workspace': typeof DashboardWorkspaceRouteRouteWithChildren
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth/signup': typeof AuthSignupRoute
  '/auth/verify-email': typeof AuthVerifyEmailRoute
  '/dashboard/my-sites': typeof DashboardMySitesRoute
  '/dashboard/reports': typeof DashboardReportsRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/company': typeof DashboardAdminCompanyRouteRouteWithChildren
  '/dashboard/sites': typeof DashboardAdminSitesRoute
  '/dashboard/user-management': typeof DashboardAdminUserManagementRoute
  '/dashboard/defects/$defectId': typeof DashboardDefectsDefectIdRoute
  '/dashboard/documents/$documentId': typeof DashboardDocumentsDocumentIdRoute
  '/dashboard/equipment/$equipmentId': typeof DashboardEquipmentEquipmentIdRoute
  '/dashboard/onboarding/document-upload': typeof DashboardOnboardingDocumentUploadRoute
  '/dashboard/onboarding/equipment-upload': typeof DashboardOnboardingEquipmentUploadRoute
  '/dashboard/onboarding/linking': typeof DashboardOnboardingLinkingRoute
  '/dashboard/scope-of-works/$scopeOfWorkId': typeof DashboardScopeOfWorksScopeOfWorkIdRoute
  '/dashboard/settings/security': typeof DashboardSettingsSecurityRoute
  '/dashboard/workspace/inspection-schedule': typeof DashboardWorkspaceInspectionScheduleRoute
  '/dashboard/workspace/inspections': typeof DashboardWorkspaceInspectionsRoute
  '/dashboard/defects/': typeof DashboardDefectsIndexRoute
  '/dashboard/documents/': typeof DashboardDocumentsIndexRoute
  '/dashboard/equipment/': typeof DashboardEquipmentIndexRoute
  '/dashboard/inspections/': typeof DashboardInspectionsIndexRoute
  '/dashboard/onboarding/': typeof DashboardOnboardingIndexRoute
  '/dashboard/scope-of-works/': typeof DashboardScopeOfWorksIndexRoute
  '/dashboard/settings/': typeof DashboardSettingsIndexRoute
  '/dashboard/workspace/': typeof DashboardWorkspaceIndexRoute
  '/dashboard/user/$userId': typeof DashboardAdminUserUserIdRoute
  '/dashboard/inspections/$inspectionId/hac-form': typeof DashboardInspectionsInspectionIdHacFormRoute
  '/dashboard/inspections/$inspectionId/paper-sheet': typeof DashboardInspectionsInspectionIdPaperSheetRoute
  '/dashboard/company/': typeof DashboardAdminCompanyIndexRoute
  '/dashboard/inspections/$inspectionId/': typeof DashboardInspectionsInspectionIdIndexRoute
  '/dashboard/company/$companyId/': typeof DashboardAdminCompanyCompanyIdIndexRoute
  '/dashboard/company/$companyId/sites/$siteId': typeof DashboardAdminCompanyCompanyIdSitesSiteIdRoute
  '/dashboard/company/$companyId/sites/': typeof DashboardAdminCompanyCompanyIdSitesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/no-access': typeof NoAccessRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth/signup': typeof AuthSignupRoute
  '/auth/verify-email': typeof AuthVerifyEmailRoute
  '/dashboard': typeof DashboardIndexRoute
  '/dashboard/my-sites': typeof DashboardMySitesRoute
  '/dashboard/reports': typeof DashboardReportsRoute
  '/dashboard/sites': typeof DashboardAdminSitesRoute
  '/dashboard/user-management': typeof DashboardAdminUserManagementRoute
  '/dashboard/defects/$defectId': typeof DashboardDefectsDefectIdRoute
  '/dashboard/documents/$documentId': typeof DashboardDocumentsDocumentIdRoute
  '/dashboard/equipment/$equipmentId': typeof DashboardEquipmentEquipmentIdRoute
  '/dashboard/onboarding/document-upload': typeof DashboardOnboardingDocumentUploadRoute
  '/dashboard/onboarding/equipment-upload': typeof DashboardOnboardingEquipmentUploadRoute
  '/dashboard/onboarding/linking': typeof DashboardOnboardingLinkingRoute
  '/dashboard/scope-of-works/$scopeOfWorkId': typeof DashboardScopeOfWorksScopeOfWorkIdRoute
  '/dashboard/settings/security': typeof DashboardSettingsSecurityRoute
  '/dashboard/workspace/inspection-schedule': typeof DashboardWorkspaceInspectionScheduleRoute
  '/dashboard/workspace/inspections': typeof DashboardWorkspaceInspectionsRoute
  '/dashboard/defects': typeof DashboardDefectsIndexRoute
  '/dashboard/documents': typeof DashboardDocumentsIndexRoute
  '/dashboard/equipment': typeof DashboardEquipmentIndexRoute
  '/dashboard/inspections': typeof DashboardInspectionsIndexRoute
  '/dashboard/onboarding': typeof DashboardOnboardingIndexRoute
  '/dashboard/scope-of-works': typeof DashboardScopeOfWorksIndexRoute
  '/dashboard/settings': typeof DashboardSettingsIndexRoute
  '/dashboard/workspace': typeof DashboardWorkspaceIndexRoute
  '/dashboard/user/$userId': typeof DashboardAdminUserUserIdRoute
  '/dashboard/inspections/$inspectionId/hac-form': typeof DashboardInspectionsInspectionIdHacFormRoute
  '/dashboard/inspections/$inspectionId/paper-sheet': typeof DashboardInspectionsInspectionIdPaperSheetRoute
  '/dashboard/company': typeof DashboardAdminCompanyIndexRoute
  '/dashboard/inspections/$inspectionId': typeof DashboardInspectionsInspectionIdIndexRoute
  '/dashboard/company/$companyId': typeof DashboardAdminCompanyCompanyIdIndexRoute
  '/dashboard/company/$companyId/sites/$siteId': typeof DashboardAdminCompanyCompanyIdSitesSiteIdRoute
  '/dashboard/company/$companyId/sites': typeof DashboardAdminCompanyCompanyIdSitesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/no-access': typeof NoAccessRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/dashboard/inspections': typeof DashboardInspectionsRouteRouteWithChildren
  '/dashboard/onboarding': typeof DashboardOnboardingRouteRouteWithChildren
  '/dashboard/settings': typeof DashboardSettingsRouteRouteWithChildren
  '/dashboard/workspace': typeof DashboardWorkspaceRouteRouteWithChildren
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth/signup': typeof AuthSignupRoute
  '/auth/verify-email': typeof AuthVerifyEmailRoute
  '/dashboard/_admin': typeof DashboardAdminRouteWithChildren
  '/dashboard/my-sites': typeof DashboardMySitesRoute
  '/dashboard/reports': typeof DashboardReportsRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/_admin/company': typeof DashboardAdminCompanyRouteRouteWithChildren
  '/dashboard/_admin/sites': typeof DashboardAdminSitesRoute
  '/dashboard/_admin/user-management': typeof DashboardAdminUserManagementRoute
  '/dashboard/defects/$defectId': typeof DashboardDefectsDefectIdRoute
  '/dashboard/documents/$documentId': typeof DashboardDocumentsDocumentIdRoute
  '/dashboard/equipment/$equipmentId': typeof DashboardEquipmentEquipmentIdRoute
  '/dashboard/onboarding/document-upload': typeof DashboardOnboardingDocumentUploadRoute
  '/dashboard/onboarding/equipment-upload': typeof DashboardOnboardingEquipmentUploadRoute
  '/dashboard/onboarding/linking': typeof DashboardOnboardingLinkingRoute
  '/dashboard/scope-of-works/$scopeOfWorkId': typeof DashboardScopeOfWorksScopeOfWorkIdRoute
  '/dashboard/settings/security': typeof DashboardSettingsSecurityRoute
  '/dashboard/workspace/inspection-schedule': typeof DashboardWorkspaceInspectionScheduleRoute
  '/dashboard/workspace/inspections': typeof DashboardWorkspaceInspectionsRoute
  '/dashboard/defects/': typeof DashboardDefectsIndexRoute
  '/dashboard/documents/': typeof DashboardDocumentsIndexRoute
  '/dashboard/equipment/': typeof DashboardEquipmentIndexRoute
  '/dashboard/inspections/': typeof DashboardInspectionsIndexRoute
  '/dashboard/onboarding/': typeof DashboardOnboardingIndexRoute
  '/dashboard/scope-of-works/': typeof DashboardScopeOfWorksIndexRoute
  '/dashboard/settings/': typeof DashboardSettingsIndexRoute
  '/dashboard/workspace/': typeof DashboardWorkspaceIndexRoute
  '/dashboard/_admin/user/$userId': typeof DashboardAdminUserUserIdRoute
  '/dashboard/inspections/$inspectionId/hac-form': typeof DashboardInspectionsInspectionIdHacFormRoute
  '/dashboard/inspections/$inspectionId/paper-sheet': typeof DashboardInspectionsInspectionIdPaperSheetRoute
  '/dashboard/_admin/company/': typeof DashboardAdminCompanyIndexRoute
  '/dashboard/inspections/$inspectionId/': typeof DashboardInspectionsInspectionIdIndexRoute
  '/dashboard/_admin/company/$companyId/': typeof DashboardAdminCompanyCompanyIdIndexRoute
  '/dashboard/_admin/company/$companyId/sites/$siteId': typeof DashboardAdminCompanyCompanyIdSitesSiteIdRoute
  '/dashboard/_admin/company/$companyId/sites/': typeof DashboardAdminCompanyCompanyIdSitesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/no-access'
    | '/privacy'
    | '/terms'
    | '/dashboard/inspections'
    | '/dashboard/onboarding'
    | '/dashboard/settings'
    | '/dashboard/workspace'
    | '/auth/reset-password'
    | '/auth/signin'
    | '/auth/signup'
    | '/auth/verify-email'
    | '/dashboard/my-sites'
    | '/dashboard/reports'
    | '/dashboard/'
    | '/dashboard/company'
    | '/dashboard/sites'
    | '/dashboard/user-management'
    | '/dashboard/defects/$defectId'
    | '/dashboard/documents/$documentId'
    | '/dashboard/equipment/$equipmentId'
    | '/dashboard/onboarding/document-upload'
    | '/dashboard/onboarding/equipment-upload'
    | '/dashboard/onboarding/linking'
    | '/dashboard/scope-of-works/$scopeOfWorkId'
    | '/dashboard/settings/security'
    | '/dashboard/workspace/inspection-schedule'
    | '/dashboard/workspace/inspections'
    | '/dashboard/defects/'
    | '/dashboard/documents/'
    | '/dashboard/equipment/'
    | '/dashboard/inspections/'
    | '/dashboard/onboarding/'
    | '/dashboard/scope-of-works/'
    | '/dashboard/settings/'
    | '/dashboard/workspace/'
    | '/dashboard/user/$userId'
    | '/dashboard/inspections/$inspectionId/hac-form'
    | '/dashboard/inspections/$inspectionId/paper-sheet'
    | '/dashboard/company/'
    | '/dashboard/inspections/$inspectionId/'
    | '/dashboard/company/$companyId/'
    | '/dashboard/company/$companyId/sites/$siteId'
    | '/dashboard/company/$companyId/sites/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/no-access'
    | '/privacy'
    | '/terms'
    | '/auth/reset-password'
    | '/auth/signin'
    | '/auth/signup'
    | '/auth/verify-email'
    | '/dashboard'
    | '/dashboard/my-sites'
    | '/dashboard/reports'
    | '/dashboard/sites'
    | '/dashboard/user-management'
    | '/dashboard/defects/$defectId'
    | '/dashboard/documents/$documentId'
    | '/dashboard/equipment/$equipmentId'
    | '/dashboard/onboarding/document-upload'
    | '/dashboard/onboarding/equipment-upload'
    | '/dashboard/onboarding/linking'
    | '/dashboard/scope-of-works/$scopeOfWorkId'
    | '/dashboard/settings/security'
    | '/dashboard/workspace/inspection-schedule'
    | '/dashboard/workspace/inspections'
    | '/dashboard/defects'
    | '/dashboard/documents'
    | '/dashboard/equipment'
    | '/dashboard/inspections'
    | '/dashboard/onboarding'
    | '/dashboard/scope-of-works'
    | '/dashboard/settings'
    | '/dashboard/workspace'
    | '/dashboard/user/$userId'
    | '/dashboard/inspections/$inspectionId/hac-form'
    | '/dashboard/inspections/$inspectionId/paper-sheet'
    | '/dashboard/company'
    | '/dashboard/inspections/$inspectionId'
    | '/dashboard/company/$companyId'
    | '/dashboard/company/$companyId/sites/$siteId'
    | '/dashboard/company/$companyId/sites'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/no-access'
    | '/privacy'
    | '/terms'
    | '/dashboard/inspections'
    | '/dashboard/onboarding'
    | '/dashboard/settings'
    | '/dashboard/workspace'
    | '/auth/reset-password'
    | '/auth/signin'
    | '/auth/signup'
    | '/auth/verify-email'
    | '/dashboard/_admin'
    | '/dashboard/my-sites'
    | '/dashboard/reports'
    | '/dashboard/'
    | '/dashboard/_admin/company'
    | '/dashboard/_admin/sites'
    | '/dashboard/_admin/user-management'
    | '/dashboard/defects/$defectId'
    | '/dashboard/documents/$documentId'
    | '/dashboard/equipment/$equipmentId'
    | '/dashboard/onboarding/document-upload'
    | '/dashboard/onboarding/equipment-upload'
    | '/dashboard/onboarding/linking'
    | '/dashboard/scope-of-works/$scopeOfWorkId'
    | '/dashboard/settings/security'
    | '/dashboard/workspace/inspection-schedule'
    | '/dashboard/workspace/inspections'
    | '/dashboard/defects/'
    | '/dashboard/documents/'
    | '/dashboard/equipment/'
    | '/dashboard/inspections/'
    | '/dashboard/onboarding/'
    | '/dashboard/scope-of-works/'
    | '/dashboard/settings/'
    | '/dashboard/workspace/'
    | '/dashboard/_admin/user/$userId'
    | '/dashboard/inspections/$inspectionId/hac-form'
    | '/dashboard/inspections/$inspectionId/paper-sheet'
    | '/dashboard/_admin/company/'
    | '/dashboard/inspections/$inspectionId/'
    | '/dashboard/_admin/company/$companyId/'
    | '/dashboard/_admin/company/$companyId/sites/$siteId'
    | '/dashboard/_admin/company/$companyId/sites/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRouteRoute: typeof DashboardRouteRouteWithChildren
  NoAccessRoute: typeof NoAccessRoute
  PrivacyRoute: typeof PrivacyRoute
  TermsRoute: typeof TermsRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSigninRoute: typeof AuthSigninRoute
  AuthSignupRoute: typeof AuthSignupRoute
  AuthVerifyEmailRoute: typeof AuthVerifyEmailRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/no-access': {
      id: '/no-access'
      path: '/no-access'
      fullPath: '/no-access'
      preLoaderRoute: typeof NoAccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/reports': {
      id: '/dashboard/reports'
      path: '/reports'
      fullPath: '/dashboard/reports'
      preLoaderRoute: typeof DashboardReportsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/my-sites': {
      id: '/dashboard/my-sites'
      path: '/my-sites'
      fullPath: '/dashboard/my-sites'
      preLoaderRoute: typeof DashboardMySitesRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/_admin': {
      id: '/dashboard/_admin'
      path: ''
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardAdminRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/auth/verify-email': {
      id: '/auth/verify-email'
      path: '/auth/verify-email'
      fullPath: '/auth/verify-email'
      preLoaderRoute: typeof AuthVerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/signup': {
      id: '/auth/signup'
      path: '/auth/signup'
      fullPath: '/auth/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/signin': {
      id: '/auth/signin'
      path: '/auth/signin'
      fullPath: '/auth/signin'
      preLoaderRoute: typeof AuthSigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/workspace': {
      id: '/dashboard/workspace'
      path: '/workspace'
      fullPath: '/dashboard/workspace'
      preLoaderRoute: typeof DashboardWorkspaceRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/settings': {
      id: '/dashboard/settings'
      path: '/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof DashboardSettingsRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/onboarding': {
      id: '/dashboard/onboarding'
      path: '/onboarding'
      fullPath: '/dashboard/onboarding'
      preLoaderRoute: typeof DashboardOnboardingRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/inspections': {
      id: '/dashboard/inspections'
      path: '/inspections'
      fullPath: '/dashboard/inspections'
      preLoaderRoute: typeof DashboardInspectionsRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/workspace/': {
      id: '/dashboard/workspace/'
      path: '/'
      fullPath: '/dashboard/workspace/'
      preLoaderRoute: typeof DashboardWorkspaceIndexRouteImport
      parentRoute: typeof DashboardWorkspaceRouteRoute
    }
    '/dashboard/settings/': {
      id: '/dashboard/settings/'
      path: '/'
      fullPath: '/dashboard/settings/'
      preLoaderRoute: typeof DashboardSettingsIndexRouteImport
      parentRoute: typeof DashboardSettingsRouteRoute
    }
    '/dashboard/scope-of-works/': {
      id: '/dashboard/scope-of-works/'
      path: '/scope-of-works'
      fullPath: '/dashboard/scope-of-works/'
      preLoaderRoute: typeof DashboardScopeOfWorksIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/onboarding/': {
      id: '/dashboard/onboarding/'
      path: '/'
      fullPath: '/dashboard/onboarding/'
      preLoaderRoute: typeof DashboardOnboardingIndexRouteImport
      parentRoute: typeof DashboardOnboardingRouteRoute
    }
    '/dashboard/inspections/': {
      id: '/dashboard/inspections/'
      path: '/'
      fullPath: '/dashboard/inspections/'
      preLoaderRoute: typeof DashboardInspectionsIndexRouteImport
      parentRoute: typeof DashboardInspectionsRouteRoute
    }
    '/dashboard/equipment/': {
      id: '/dashboard/equipment/'
      path: '/equipment'
      fullPath: '/dashboard/equipment/'
      preLoaderRoute: typeof DashboardEquipmentIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/documents/': {
      id: '/dashboard/documents/'
      path: '/documents'
      fullPath: '/dashboard/documents/'
      preLoaderRoute: typeof DashboardDocumentsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/defects/': {
      id: '/dashboard/defects/'
      path: '/defects'
      fullPath: '/dashboard/defects/'
      preLoaderRoute: typeof DashboardDefectsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/workspace/inspections': {
      id: '/dashboard/workspace/inspections'
      path: '/inspections'
      fullPath: '/dashboard/workspace/inspections'
      preLoaderRoute: typeof DashboardWorkspaceInspectionsRouteImport
      parentRoute: typeof DashboardWorkspaceRouteRoute
    }
    '/dashboard/workspace/inspection-schedule': {
      id: '/dashboard/workspace/inspection-schedule'
      path: '/inspection-schedule'
      fullPath: '/dashboard/workspace/inspection-schedule'
      preLoaderRoute: typeof DashboardWorkspaceInspectionScheduleRouteImport
      parentRoute: typeof DashboardWorkspaceRouteRoute
    }
    '/dashboard/settings/security': {
      id: '/dashboard/settings/security'
      path: '/security'
      fullPath: '/dashboard/settings/security'
      preLoaderRoute: typeof DashboardSettingsSecurityRouteImport
      parentRoute: typeof DashboardSettingsRouteRoute
    }
    '/dashboard/scope-of-works/$scopeOfWorkId': {
      id: '/dashboard/scope-of-works/$scopeOfWorkId'
      path: '/scope-of-works/$scopeOfWorkId'
      fullPath: '/dashboard/scope-of-works/$scopeOfWorkId'
      preLoaderRoute: typeof DashboardScopeOfWorksScopeOfWorkIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/onboarding/linking': {
      id: '/dashboard/onboarding/linking'
      path: '/linking'
      fullPath: '/dashboard/onboarding/linking'
      preLoaderRoute: typeof DashboardOnboardingLinkingRouteImport
      parentRoute: typeof DashboardOnboardingRouteRoute
    }
    '/dashboard/onboarding/equipment-upload': {
      id: '/dashboard/onboarding/equipment-upload'
      path: '/equipment-upload'
      fullPath: '/dashboard/onboarding/equipment-upload'
      preLoaderRoute: typeof DashboardOnboardingEquipmentUploadRouteImport
      parentRoute: typeof DashboardOnboardingRouteRoute
    }
    '/dashboard/onboarding/document-upload': {
      id: '/dashboard/onboarding/document-upload'
      path: '/document-upload'
      fullPath: '/dashboard/onboarding/document-upload'
      preLoaderRoute: typeof DashboardOnboardingDocumentUploadRouteImport
      parentRoute: typeof DashboardOnboardingRouteRoute
    }
    '/dashboard/equipment/$equipmentId': {
      id: '/dashboard/equipment/$equipmentId'
      path: '/equipment/$equipmentId'
      fullPath: '/dashboard/equipment/$equipmentId'
      preLoaderRoute: typeof DashboardEquipmentEquipmentIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/documents/$documentId': {
      id: '/dashboard/documents/$documentId'
      path: '/documents/$documentId'
      fullPath: '/dashboard/documents/$documentId'
      preLoaderRoute: typeof DashboardDocumentsDocumentIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/defects/$defectId': {
      id: '/dashboard/defects/$defectId'
      path: '/defects/$defectId'
      fullPath: '/dashboard/defects/$defectId'
      preLoaderRoute: typeof DashboardDefectsDefectIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/_admin/user-management': {
      id: '/dashboard/_admin/user-management'
      path: '/user-management'
      fullPath: '/dashboard/user-management'
      preLoaderRoute: typeof DashboardAdminUserManagementRouteImport
      parentRoute: typeof DashboardAdminRoute
    }
    '/dashboard/_admin/sites': {
      id: '/dashboard/_admin/sites'
      path: '/sites'
      fullPath: '/dashboard/sites'
      preLoaderRoute: typeof DashboardAdminSitesRouteImport
      parentRoute: typeof DashboardAdminRoute
    }
    '/dashboard/_admin/company': {
      id: '/dashboard/_admin/company'
      path: '/company'
      fullPath: '/dashboard/company'
      preLoaderRoute: typeof DashboardAdminCompanyRouteRouteImport
      parentRoute: typeof DashboardAdminRoute
    }
    '/dashboard/inspections/$inspectionId/': {
      id: '/dashboard/inspections/$inspectionId/'
      path: '/$inspectionId'
      fullPath: '/dashboard/inspections/$inspectionId/'
      preLoaderRoute: typeof DashboardInspectionsInspectionIdIndexRouteImport
      parentRoute: typeof DashboardInspectionsRouteRoute
    }
    '/dashboard/_admin/company/': {
      id: '/dashboard/_admin/company/'
      path: '/'
      fullPath: '/dashboard/company/'
      preLoaderRoute: typeof DashboardAdminCompanyIndexRouteImport
      parentRoute: typeof DashboardAdminCompanyRouteRoute
    }
    '/dashboard/inspections/$inspectionId/paper-sheet': {
      id: '/dashboard/inspections/$inspectionId/paper-sheet'
      path: '/$inspectionId/paper-sheet'
      fullPath: '/dashboard/inspections/$inspectionId/paper-sheet'
      preLoaderRoute: typeof DashboardInspectionsInspectionIdPaperSheetRouteImport
      parentRoute: typeof DashboardInspectionsRouteRoute
    }
    '/dashboard/inspections/$inspectionId/hac-form': {
      id: '/dashboard/inspections/$inspectionId/hac-form'
      path: '/$inspectionId/hac-form'
      fullPath: '/dashboard/inspections/$inspectionId/hac-form'
      preLoaderRoute: typeof DashboardInspectionsInspectionIdHacFormRouteImport
      parentRoute: typeof DashboardInspectionsRouteRoute
    }
    '/dashboard/_admin/user/$userId': {
      id: '/dashboard/_admin/user/$userId'
      path: '/user/$userId'
      fullPath: '/dashboard/user/$userId'
      preLoaderRoute: typeof DashboardAdminUserUserIdRouteImport
      parentRoute: typeof DashboardAdminRoute
    }
    '/dashboard/_admin/company/$companyId/': {
      id: '/dashboard/_admin/company/$companyId/'
      path: '/$companyId'
      fullPath: '/dashboard/company/$companyId/'
      preLoaderRoute: typeof DashboardAdminCompanyCompanyIdIndexRouteImport
      parentRoute: typeof DashboardAdminCompanyRouteRoute
    }
    '/dashboard/_admin/company/$companyId/sites/': {
      id: '/dashboard/_admin/company/$companyId/sites/'
      path: '/$companyId/sites'
      fullPath: '/dashboard/company/$companyId/sites/'
      preLoaderRoute: typeof DashboardAdminCompanyCompanyIdSitesIndexRouteImport
      parentRoute: typeof DashboardAdminCompanyRouteRoute
    }
    '/dashboard/_admin/company/$companyId/sites/$siteId': {
      id: '/dashboard/_admin/company/$companyId/sites/$siteId'
      path: '/$companyId/sites/$siteId'
      fullPath: '/dashboard/company/$companyId/sites/$siteId'
      preLoaderRoute: typeof DashboardAdminCompanyCompanyIdSitesSiteIdRouteImport
      parentRoute: typeof DashboardAdminCompanyRouteRoute
    }
  }
}

interface DashboardInspectionsRouteRouteChildren {
  DashboardInspectionsIndexRoute: typeof DashboardInspectionsIndexRoute
  DashboardInspectionsInspectionIdHacFormRoute: typeof DashboardInspectionsInspectionIdHacFormRoute
  DashboardInspectionsInspectionIdPaperSheetRoute: typeof DashboardInspectionsInspectionIdPaperSheetRoute
  DashboardInspectionsInspectionIdIndexRoute: typeof DashboardInspectionsInspectionIdIndexRoute
}

const DashboardInspectionsRouteRouteChildren: DashboardInspectionsRouteRouteChildren =
  {
    DashboardInspectionsIndexRoute: DashboardInspectionsIndexRoute,
    DashboardInspectionsInspectionIdHacFormRoute:
      DashboardInspectionsInspectionIdHacFormRoute,
    DashboardInspectionsInspectionIdPaperSheetRoute:
      DashboardInspectionsInspectionIdPaperSheetRoute,
    DashboardInspectionsInspectionIdIndexRoute:
      DashboardInspectionsInspectionIdIndexRoute,
  }

const DashboardInspectionsRouteRouteWithChildren =
  DashboardInspectionsRouteRoute._addFileChildren(
    DashboardInspectionsRouteRouteChildren,
  )

interface DashboardOnboardingRouteRouteChildren {
  DashboardOnboardingDocumentUploadRoute: typeof DashboardOnboardingDocumentUploadRoute
  DashboardOnboardingEquipmentUploadRoute: typeof DashboardOnboardingEquipmentUploadRoute
  DashboardOnboardingLinkingRoute: typeof DashboardOnboardingLinkingRoute
  DashboardOnboardingIndexRoute: typeof DashboardOnboardingIndexRoute
}

const DashboardOnboardingRouteRouteChildren: DashboardOnboardingRouteRouteChildren =
  {
    DashboardOnboardingDocumentUploadRoute:
      DashboardOnboardingDocumentUploadRoute,
    DashboardOnboardingEquipmentUploadRoute:
      DashboardOnboardingEquipmentUploadRoute,
    DashboardOnboardingLinkingRoute: DashboardOnboardingLinkingRoute,
    DashboardOnboardingIndexRoute: DashboardOnboardingIndexRoute,
  }

const DashboardOnboardingRouteRouteWithChildren =
  DashboardOnboardingRouteRoute._addFileChildren(
    DashboardOnboardingRouteRouteChildren,
  )

interface DashboardSettingsRouteRouteChildren {
  DashboardSettingsSecurityRoute: typeof DashboardSettingsSecurityRoute
  DashboardSettingsIndexRoute: typeof DashboardSettingsIndexRoute
}

const DashboardSettingsRouteRouteChildren: DashboardSettingsRouteRouteChildren =
  {
    DashboardSettingsSecurityRoute: DashboardSettingsSecurityRoute,
    DashboardSettingsIndexRoute: DashboardSettingsIndexRoute,
  }

const DashboardSettingsRouteRouteWithChildren =
  DashboardSettingsRouteRoute._addFileChildren(
    DashboardSettingsRouteRouteChildren,
  )

interface DashboardWorkspaceRouteRouteChildren {
  DashboardWorkspaceInspectionScheduleRoute: typeof DashboardWorkspaceInspectionScheduleRoute
  DashboardWorkspaceInspectionsRoute: typeof DashboardWorkspaceInspectionsRoute
  DashboardWorkspaceIndexRoute: typeof DashboardWorkspaceIndexRoute
}

const DashboardWorkspaceRouteRouteChildren: DashboardWorkspaceRouteRouteChildren =
  {
    DashboardWorkspaceInspectionScheduleRoute:
      DashboardWorkspaceInspectionScheduleRoute,
    DashboardWorkspaceInspectionsRoute: DashboardWorkspaceInspectionsRoute,
    DashboardWorkspaceIndexRoute: DashboardWorkspaceIndexRoute,
  }

const DashboardWorkspaceRouteRouteWithChildren =
  DashboardWorkspaceRouteRoute._addFileChildren(
    DashboardWorkspaceRouteRouteChildren,
  )

interface DashboardAdminCompanyRouteRouteChildren {
  DashboardAdminCompanyIndexRoute: typeof DashboardAdminCompanyIndexRoute
  DashboardAdminCompanyCompanyIdIndexRoute: typeof DashboardAdminCompanyCompanyIdIndexRoute
  DashboardAdminCompanyCompanyIdSitesSiteIdRoute: typeof DashboardAdminCompanyCompanyIdSitesSiteIdRoute
  DashboardAdminCompanyCompanyIdSitesIndexRoute: typeof DashboardAdminCompanyCompanyIdSitesIndexRoute
}

const DashboardAdminCompanyRouteRouteChildren: DashboardAdminCompanyRouteRouteChildren =
  {
    DashboardAdminCompanyIndexRoute: DashboardAdminCompanyIndexRoute,
    DashboardAdminCompanyCompanyIdIndexRoute:
      DashboardAdminCompanyCompanyIdIndexRoute,
    DashboardAdminCompanyCompanyIdSitesSiteIdRoute:
      DashboardAdminCompanyCompanyIdSitesSiteIdRoute,
    DashboardAdminCompanyCompanyIdSitesIndexRoute:
      DashboardAdminCompanyCompanyIdSitesIndexRoute,
  }

const DashboardAdminCompanyRouteRouteWithChildren =
  DashboardAdminCompanyRouteRoute._addFileChildren(
    DashboardAdminCompanyRouteRouteChildren,
  )

interface DashboardAdminRouteChildren {
  DashboardAdminCompanyRouteRoute: typeof DashboardAdminCompanyRouteRouteWithChildren
  DashboardAdminSitesRoute: typeof DashboardAdminSitesRoute
  DashboardAdminUserManagementRoute: typeof DashboardAdminUserManagementRoute
  DashboardAdminUserUserIdRoute: typeof DashboardAdminUserUserIdRoute
}

const DashboardAdminRouteChildren: DashboardAdminRouteChildren = {
  DashboardAdminCompanyRouteRoute: DashboardAdminCompanyRouteRouteWithChildren,
  DashboardAdminSitesRoute: DashboardAdminSitesRoute,
  DashboardAdminUserManagementRoute: DashboardAdminUserManagementRoute,
  DashboardAdminUserUserIdRoute: DashboardAdminUserUserIdRoute,
}

const DashboardAdminRouteWithChildren = DashboardAdminRoute._addFileChildren(
  DashboardAdminRouteChildren,
)

interface DashboardRouteRouteChildren {
  DashboardInspectionsRouteRoute: typeof DashboardInspectionsRouteRouteWithChildren
  DashboardOnboardingRouteRoute: typeof DashboardOnboardingRouteRouteWithChildren
  DashboardSettingsRouteRoute: typeof DashboardSettingsRouteRouteWithChildren
  DashboardWorkspaceRouteRoute: typeof DashboardWorkspaceRouteRouteWithChildren
  DashboardAdminRoute: typeof DashboardAdminRouteWithChildren
  DashboardMySitesRoute: typeof DashboardMySitesRoute
  DashboardReportsRoute: typeof DashboardReportsRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardDefectsDefectIdRoute: typeof DashboardDefectsDefectIdRoute
  DashboardDocumentsDocumentIdRoute: typeof DashboardDocumentsDocumentIdRoute
  DashboardEquipmentEquipmentIdRoute: typeof DashboardEquipmentEquipmentIdRoute
  DashboardScopeOfWorksScopeOfWorkIdRoute: typeof DashboardScopeOfWorksScopeOfWorkIdRoute
  DashboardDefectsIndexRoute: typeof DashboardDefectsIndexRoute
  DashboardDocumentsIndexRoute: typeof DashboardDocumentsIndexRoute
  DashboardEquipmentIndexRoute: typeof DashboardEquipmentIndexRoute
  DashboardScopeOfWorksIndexRoute: typeof DashboardScopeOfWorksIndexRoute
}

const DashboardRouteRouteChildren: DashboardRouteRouteChildren = {
  DashboardInspectionsRouteRoute: DashboardInspectionsRouteRouteWithChildren,
  DashboardOnboardingRouteRoute: DashboardOnboardingRouteRouteWithChildren,
  DashboardSettingsRouteRoute: DashboardSettingsRouteRouteWithChildren,
  DashboardWorkspaceRouteRoute: DashboardWorkspaceRouteRouteWithChildren,
  DashboardAdminRoute: DashboardAdminRouteWithChildren,
  DashboardMySitesRoute: DashboardMySitesRoute,
  DashboardReportsRoute: DashboardReportsRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardDefectsDefectIdRoute: DashboardDefectsDefectIdRoute,
  DashboardDocumentsDocumentIdRoute: DashboardDocumentsDocumentIdRoute,
  DashboardEquipmentEquipmentIdRoute: DashboardEquipmentEquipmentIdRoute,
  DashboardScopeOfWorksScopeOfWorkIdRoute:
    DashboardScopeOfWorksScopeOfWorkIdRoute,
  DashboardDefectsIndexRoute: DashboardDefectsIndexRoute,
  DashboardDocumentsIndexRoute: DashboardDocumentsIndexRoute,
  DashboardEquipmentIndexRoute: DashboardEquipmentIndexRoute,
  DashboardScopeOfWorksIndexRoute: DashboardScopeOfWorksIndexRoute,
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(
  DashboardRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRouteRoute: DashboardRouteRouteWithChildren,
  NoAccessRoute: NoAccessRoute,
  PrivacyRoute: PrivacyRoute,
  TermsRoute: TermsRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSigninRoute: AuthSigninRoute,
  AuthSignupRoute: AuthSignupRoute,
  AuthVerifyEmailRoute: AuthVerifyEmailRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
